/* src/modules/dashboard/reducers.js */

import { combineReducers } from 'redux';
import { keyBy } from 'lodash';

import {
  fetchDashboardLessonsTypes,
  fetchDashboardUsersTypes,
  fetchDashboardStudentsTypes,
  fetchDashboardTutorsTypes,
  fetchPopularCoursesTypes,
  CHANGE_NUMBER_OF_LESSONS_TIME_FRAME,
  CHANGE_NUMBER_OF_LESSONS_TYPE,
  CHANGE_NUMBER_OF_LESSONS_START_DATE,
  CHANGE_NUMBER_OF_LESSONS_END_DATE,
  CHANGE_NUMBER_OF_USERS_TIME_FRAME,
  CHANGE_NUMBER_OF_USERS_TYPE,
  CHANGE_NUMBER_OF_USERS_START_DATE,
  CHANGE_NUMBER_OF_USERS_END_DATE,
  CHANGE_REVENUE_TIME_FRAME,
  CHANGE_REVENUE_TYPE,
  CHANGE_REVENUE_START_DATE,
  CHANGE_REVENUE_END_DATE,
  CHANGE_PROFIT_TIME_FRAME,
  CHANGE_PROFIT_TYPE,
  CHANGE_PROFIT_START_DATE,
  CHANGE_PROFIT_END_DATE,
} from './action_types';

import { ON_ERROR } from '../app_state/action_types';

import { makeRequestReducer } from '../../config/client';

const normalize = (state, res) => keyBy(res, '_id');
const onError = (state, action) => {
  switch (action.type) {
    case ON_ERROR:
      return { ...state, data: {} };
    default:
      return state;
  }
};

const lessons = makeRequestReducer({
  types: fetchDashboardLessonsTypes,
  name: 'lessons',
  mutate: normalize,
  append: [onError],
});

const users = makeRequestReducer({
  types: fetchDashboardUsersTypes,
  name: 'users',
  mutate: normalize,
  append: [onError],
});

const students = makeRequestReducer({
  types: fetchDashboardStudentsTypes,
  name: 'students',
  mutate: normalize,
  append: [onError],
});

const tutors = makeRequestReducer({
  types: fetchDashboardTutorsTypes,
  name: 'tutors',
  mutate: normalize,
  append: [onError],
});

const popularCourses = makeRequestReducer({
  types: fetchPopularCoursesTypes,
  name: 'popularCourses',
});

const initialGraphState = {
  numberOfLessonsTimeFrame: 'day',
  numberOfLessonsType: 'requested',
  numberOfLessonsStartDate: '',
  numberOfLessonsEndDate: '',
  numberOfUsersTimeFrame: 'day',
  numberOfUsersType: 'student',
  numberOfUsersStartDate: '',
  numberOfUsersEndDate: '',
  revenueTimeFrame: 'day',
  revenueType: 'completed',
  revenueStartDate: '',
  revenueEndDate: '',
  profitTimeFrame: 'day',
  profitType: 'student',
  profitStartDate: '',
  profitEndDate: '',
};

const graphs = (state = initialGraphState, action) => {
  switch (action.type) {
    case CHANGE_NUMBER_OF_LESSONS_TIME_FRAME:
      return { ...state, numberOfLessonsTimeFrame: action.payload };
    case CHANGE_NUMBER_OF_LESSONS_TYPE:
      return { ...state, numberOfLessonsType: action.payload };
    case CHANGE_NUMBER_OF_LESSONS_START_DATE:
      return { ...state, numberOfLessonsStartDate: action.payload };
    case CHANGE_NUMBER_OF_LESSONS_END_DATE:
      return { ...state, numberOfLessonsEndDate: action.payload };
    case CHANGE_NUMBER_OF_USERS_TIME_FRAME:
      return { ...state, numberOfUsersTimeFrame: action.payload };
    case CHANGE_NUMBER_OF_USERS_TYPE:
      return { ...state, numberOfUsersType: action.payload };
    case CHANGE_NUMBER_OF_USERS_START_DATE:
      return { ...state, numberOfUsersStartDate: action.payload };
    case CHANGE_NUMBER_OF_USERS_END_DATE:
      return { ...state, numberOfUsersEndDate: action.payload };
    case CHANGE_REVENUE_TIME_FRAME:
      return { ...state, revenueTimeFrame: action.payload };
    case CHANGE_REVENUE_TYPE:
      return { ...state, revenueType: action.payload };
    case CHANGE_REVENUE_START_DATE:
      return { ...state, revenueStartDate: action.payload };
    case CHANGE_REVENUE_END_DATE:
      return { ...state, revenueEndDate: action.payload };
    case CHANGE_PROFIT_TIME_FRAME:
      return { ...state, profitTimeFrame: action.payload };
    case CHANGE_PROFIT_TYPE:
      return { ...state, profitType: action.payload };
    case CHANGE_PROFIT_START_DATE:
      return { ...state, profitStartDate: action.payload };
    case CHANGE_PROFIT_END_DATE:
      return { ...state, profitEndDate: action.payload };
    case ON_ERROR:
      return { ...state, ...initialGraphState };
    default:
      return state;
  }
};

export default combineReducers({
  lessons,
  users,
  students,
  tutors,
  graphs,
  popularCourses,
});



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers.js